import { TemplateResult, html } from 'lit';
import { OutlineElement } from '@phase2/outline-core';
import { customElement } from 'lit/decorators.js';
import { AdoptedStyleSheets } from '@phase2/outline-adopted-stylesheets-controller';

import globalStyles from './pc-admin-links.lightDom.css.lit';

/**
 * The Admin Links component
 * @element pc-admin-links
 * @extends OutlineElement
 * @slot - The default slot for this element.
 */
@customElement('pc-admin-links')
export class PCAdminLinks extends OutlineElement {
  adoptedStylesheets: AdoptedStyleSheets;

  /**
   * The `connectedCallback` method is called whenever the element is inserted into the DOM.
   * In this method, we're creating an instance of `AdoptedStyleSheets` and adding it as a controller.
   *
   * Adding the `AdoptedStylesheets` controller via `connectedCallback` is more efficient than creating
   * the instance and adding the controller in the `constructor`.
   * The reason is that it delays these operations until the element is actually inserted into the DOM.
   * If you have many such elements that are created but not immediately added to the DOM,
   * this can improve the startup performance of your application.
   */
  connectedCallback() {
    super.connectedCallback();
    this.adoptedStylesheets = new AdoptedStyleSheets(globalStyles);
    this.addController(this.adoptedStylesheets);
  }

  render(): TemplateResult {
    return html` <div class="links"><slot></slot></div> `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'pc-admin-links': PCAdminLinks;
  }
}
